export default {
  RESPONSABLES_CAMPAGNE: 'Responsables de la campagne',
  DELETE_CONFIRMATION_TITLE: 'Confirmation de suppression',
  DELETE_CONFIRMATION_MESSAGE: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  SELECT: 'Sélectionner',
  LOADING: 'Chargement...',
  NOT_FOR_MEDICAL_DATA: "Ce service n'est pas conçu pour transmettre et stocker des données à caractère médical.",
  JOindre_un_document_de_justification_facultatif: 'Joindre un document de justification (facultatif)',
  SELECT_USER_CONGE: 'Veuillez sélectionner un collaborateur',
  DECLARERCONGE: 'Déclarer un congé pour un collaborateur',
  DEMANDERCONGE: 'Demander un congé',
  LEAVE_MODAL_SUBTITLE: 'Renseignez les détails de votre demande',
  DISPONIBILITES_EQUIPE: 'Disponibilités de l\'équipe',
  SELECT_USER_TO_VIEW_CALENDAR: 'Sélectionnez un collaborateur pour afficher le calendrier',
  TYPE_CONGE: 'Type de congé',
  COLLABORATEUR: 'Collaborateur',
  DATE_CONFLIT:
    'La date de début et/ou la date de fin est en conflit avec un autre congé existant. Veuillez vérifier les dates et réessayer.',
  PERIODE: 'Période',
  JOURNEE: 'Journée',
  DEMI_JOURNEE: 'Demi-journée',
  MATIN: 'Matin',
  APRES_MIDI: 'Après-midi',
  DATE_DEBUT: 'Date de début',
  DATE: 'Date',
  DATE_FIN: 'Date de fin',
  TIME: 'Heure',
  COMMENTAIRE_FACULTATIF: 'Commentaire (facultatif)',
  IMPORTER_FICHIER: 'Importer un fichier',
  CHARGEMENT: 'Chargement...',
  SHOW_MORE: 'Voir plus',
  SHOW_LESS: 'Voir moins',
  SOLDE_CONGES: 'Solde de congés',
  RTT: 'RTT',
  CONGES_PAYES: 'Congés payés',
  JOURS: 'jours',
  JOUR: 'jour',
  TOTAL_JOURS_DEMANDES: 'Total de jours demandés',
  LEAVE_BALANCE_EXCEEDED: 'Attention : le nombre de jours demandés dépasse le solde de congés.',
  EN_COURS: 'En cours...',
  SOUMETTRE: 'Soumettre',
  LIGNEINSEREE: 'Ligne insérée',
  LIGNESINSEREES: 'Lignes insérées',
  LIGNEREJETEE: 'Rejetée',
  LIGNESREJETEES: 'Rejetées',
  TOTAL: 'Total',
  DATE_DEMARRAGE: 'Date de démarrage',

  ERROR_OCCURRED: 'Journée déjà  validée',
  AES_WARNING:
    'Vous avez utilisé la vérification AES :  Le crédit requis pour la signature de ce document est désormais de ',
  RETIRERDELAISTEDESPERSONNESMANAGEES: 'Retirer de la liste des personnes managées',
  VoirLaFicheDetailleeDuCollaborateur: 'Voir la fiche détaillée du collaborateur',
  RETIRER: 'Retirer',
  ACTIONS: 'Actions',
  actions: 'Actions',
  NEW_MAIL_RECEIVED: 'Un nouveau mail reçu de la part du candidat',
  MAIL_COMMUNICATION_INFO:
    'Toute communication avec le candidat doit se faire via cette adresse, sinon elle ne sera pas enregistrée.',
  COMMUNITY: 'Communauté',
  ENTERPRISE: 'Entreprise',
  MEMBER: 'Membre',
  DESCRIPTION: 'Description',
  TITLE: 'Titre',
  NBR: 'Nombre',
  FNAME: 'Prénom',
  LNAME: 'Nom',
  CREATED_AT: 'Créé le',
  CREATED_ON: 'Date de création',
  IMG: 'Image',
  NAME: 'Nom',
  SEARCH: 'Rechercher',
  IN_ANY_FIELD: "dans n'importe quel champ",
  BTN_DELETE: 'Supprimer',
  BTN_SAVE: 'Enregistrer',
  BTN_CONFIRM: 'Confirmer',
  BTN_CANCEL: 'Annuler',
  ACCEPTER: 'Accepter',
  BTN_CLOSE: 'Fermer',
  BTN_ADD: 'Ajouter',
  BTN_UPDATE: 'Mettre à jour',
  BTN_CREATE: 'Créer',
  DUPLICATE: 'Dupliquer',
  OPTIONAL: 'Optionnel',
  SELECT_ALL: 'Tout sélectionner',
  CLEAR_ALL: 'Tout désélectionner',
  FILL_PREVIOUS_FIELD: "Veuillez d'abord remplir la première période d'essai",
  ALLOWED_FILE_TYPES: 'Types de fichiers autorisés',
  THE_FIELD: 'Le champ ',
  INPUT_VALIDATION: {
    MIN: ` doit comporter au moins {{min}} caractères`,
    MAX: ` doit comporter au plus {{max}} caractères`,
  },
  SHOWING_ROWS_TABLE: 'Affichage des lignes {{from}} à {{to}} sur {{of}}',
  OPERATION_SUCCESS: 'Opération réussie',
  OPERATION_SUCCESS_SEND_EMAIL: 'Email envoyé avec succès',
  OPERATION_FAILED_SEND_EMAIL: "Échec de l'envoi de l'email",
  OPERATION_FAILED: 'Opération échouée !',
  MODAL_AUTO_CLOSED: "La fenêtre a été fermée automatiquement après 5 minutes d'inactivité",
  OPERATION_WARNING:
    "Cette stratégie est disponible dans un plan premium ! Veuillez passer au plan premium pour l'utiliser !",
  REFRESH: 'Actualiser la liste',
  REFRESH_SUCCESS: 'Actualisation réussie',
  REFRESH_ERROR: "Erreur lors de l'actualisation",
  OPENS_NEW_TAB: "S'ouvre dans un nouvel onglet",

  SKILL_TYPE_REQUIRED: 'Le type de compétence est obligatoire',
  SKILL_INVALID: 'La compétence sélectionnée est invalide',
  SKILL_ADDED_ESSENTIAL: 'Compétence ajoutée aux compétences essentielles',
  SKILL_ADDED_OPTIONAL: 'Compétence ajoutée aux compétences optionnelles',
  SKILL_REMOVED: 'Compétence retirée',
  SKILL_UPDATE_REMINDER: "Pensez à mettre à jour l'offre ou à la régénérer",
  SKILL_ALREADY_EXISTS_IN_ESSENTIAL: 'La compétence existe déjà dans les compétences essentielles',
  SKILL_ALREADY_EXISTS_IN_OPTIONAL: 'La compétence existe déjà dans les compétences optionnelles',
  SKILL_ADDED_SUCCESSFULLY: 'Compétence ajoutée avec succès',

  JOB_OFFER_UPDATED: "Offre d'emploi mise à jour avec succès",
  JOB_OFFER_UPDATE_ERROR: "Une erreur s'est produite lors de la mise à jour de l'offre",
  JOB_OFFER_UPDATED_SUCCESSFULLY: "Offre d'emploi mise à jour avec succès",

  DESCRIPTION_ENTREPRISE: "Description de l'entreprise",
  DESCRIPTION_ENTREPRISE_PLACEHOLDER: "Métier de l'entreprise",
  DESCRIPTION_ENTREPRISE_TOOLTIP:
    "C'est une courte description de votre entreprise pour aidé Emye a mieux vous connaitre",
  ERROR_UPDATING_JOB_OFFER: "Une erreur s'est produite lors de la mise à jour de l'offre",

  SUCCESS: 'Succès',
  ERROR: 'Erreur',
  WARNING: 'Avertissement',
  INFO: 'Information',
  NEW: 'Nouveau',

  EXAMPLE: 'Exemple',
  LANG: 'Langue',
  ENTERPRISE_LANGUAGES: "Langues de l'entreprise",
  LANGUAGES: {
    fr: 'Français',
    en: 'Anglais',
    es: 'Espagnol',
    de: 'Allemand',
    it: 'Italien',
    ar: 'Arabe',
  },
  DAY_OF_WEEK: {
    MON: 'Lundi',
    TUE: 'Mardi',
    WED: 'Mercredi',
    THU: 'Jeudi',
    FRI: 'Vendredi',
    SAT: 'Samedi',
    SUN: 'Dimanche',
  },

  // Nouvelles clés de traduction pour la fonctionnalité d'édition des questions
  EDIT: 'Modifier',
  CANCEL: 'Annuler',
  SAVE: 'Enregistrer',
  SAVE_AND_CLOSE: 'Enregistrer et fermer',
  SAVING: 'Enregistrement...',
  // Labels used by the interview workflow autosave status indicator.
  SAVED: 'Enregistré',
  ADD: 'Ajouter',
  ALL: 'Tous',
  All: 'Tous',
  PREVIOUS: 'Précédent',
  NEXT: 'Suivant',
  STEPS: 'Étapes',
  FEMYE: 'Assistant IA RH',
  FNOAH: 'Coach IA RH',
  FJULIE: 'Compagnon IA Juridique',
  FTHOMAS: 'Compagnon IA CSRD',
  FALAIN: 'Compagnon IA Support',
  FSECUREGPT: 'Assistant IA Général',
  FCLARA: 'Compagnon IA Recrutement',
  REPMESSUCCESS: 'Message signalé avec succès',
  REPMESFAILED: 'Échec du signalement du message',
  REPSEND: 'Envoyer',
  NEW_VERSION_AVAILABLE:
    "Une mise à jour de l'application est disponible. Vous devez mettre à jour l'application pour pouvoir continuer.",
  NEW_VERSION_AVAILABLE_TITLE: 'Une nouvelle version est disponible',
  NEW_VERSION_AVAILABLE_MESSAGE: 'Une nouvelle version est disponible. Le site va se recharger.',
  NEW_VERSION_AVAILABLE_BUTTON: 'Mettre à jour',
  // REPCANCEL: 'Annuler',
  // REPTITLE: 'Signaler un message',
  // REPPH: 'Veuillez décrire la raison du signalement de ce message...',
  // DESCRIPTION_ENTREPRISE: "Description de l'entreprise",
  // DESCRIPTION_ENTREPRISE_PLACEHOLDER: "Secteur d'activité de l'entreprise",
  // DESCRIPTION_ENTREPRISE_TOOLTIP: "Il s'agit d'une brève description de votre entreprise pour aider Emye à mieux comprendre vos besoins.",

  ADDNEWQUESTION: 'Ajouter une nouvelle question',
  ENTERQUESTION: 'Saisir la question',
  QUESTIONSSAVEDSUCCESS: 'Questions enregistrées avec succès',
  QUESTIONADDEDSUCCESS: 'Question ajoutée avec succès',
  QUESTIONDELETEDSUCCESS: 'Question supprimée avec succès',
  QUESTIONEDITEDSUCCESS: 'Question modifiée avec succès',
  ERRORLOADINGQUESTIONS: 'Erreur lors du chargement des questions',
  ERRORSAVINGQUESTIONS: 'Erreur lors de la sauvegarde des questions',
  ERRORADDINGQUESTION: "Erreur lors de l'ajout de la question",
  ERRORDELETINGQUESTION: 'Erreur lors de la suppression de la question',
  ERROREDITINGQUESTION: 'Erreur lors de la modification de la question',
  MISSINGPARAMETERS: 'Paramètres manquants',

  REPCANCEL: 'Annuler',
  // Les libellés structurés rendent le signalement des réponses IA explicite, obligatoire et auditable.
  REPTITLE: 'Signaler cette réponse IA',
  REPPH: 'Ajoutez un commentaire facultatif...',
  REPORT_REASON_LABEL: 'Motif du signalement',
  REPORT_REASON_PLACEHOLDER: 'Sélectionnez un motif',
  REPORT_REASON_HARMFUL: 'Contenu dangereux ou préjudiciable',
  REPORT_REASON_OFFENSIVE: 'Contenu offensant ou discriminatoire',
  REPORT_REASON_INCORRECT: 'Information incorrecte ou trompeuse',
  REPORT_REASON_PRIVACY: 'Problème de confidentialité ou de données',
  REPORT_REASON_OTHER: 'Autre',
  REPORT_COMMENT_LABEL: 'Commentaire',
  REPORT_OTHER_COMMENT_REQUIRED: 'Décrivez le problème lorsque vous choisissez « Autre ».',
  REPORT_POLICY_NOTICE: 'Votre signalement sera conservé et examiné par un modérateur autorisé.',
  REPORT_TERMS_LINK: "Conditions d'utilisation",
  REPORT_PRIVACY_LINK: 'Politique de confidentialité',
  TEXTIA:
    "Ces documents sont générés par l'IA et sont fournis à titre informatif uniquement. Veuillez examiner leur contenu et les adapter avec l'aide d'un professionnel avant utilisation.",
  NOMMODELE: 'Nom du modèle',
  TEXTINFOPERSONALISER:
    "Vous n'avez pas à mettre de caractères spéciaux pour les noms et prénoms, vous pouvez les copier directement et l'IA remplacera automatiquement les champs avec les bonnes informations.",
  AJOUTMODELEPERSONALISER: 'Ajouter un modèle personnalisé',
  ENREGISTREMODEL: 'Enregistrer',
  PERSONALIZED_MODEL_VIEW_TITLE: 'Visualiser le modèle personnalisé',
  PERSONALIZED_MODEL_EDIT_TITLE: 'Modifier le modèle personnalisé',
  PERSONALIZED_MODEL_SAVE_CHANGES: 'Enregistrer les modifications',
  PERSONALIZED_MODEL_CREATE_SUCCESS: 'Modèle personnalisé ajouté avec succès',
  PERSONALIZED_MODEL_CREATE_ERROR: "Erreur lors de l'ajout du modèle personnalisé",
  PERSONALIZED_MODEL_UPDATE_SUCCESS: 'Modèle personnalisé mis à jour avec succès',
  PERSONALIZED_MODEL_UPDATE_ERROR: 'Erreur lors de la mise à jour du modèle personnalisé',
  PERSONALIZED_MODEL_DELETE_TITLE: 'Supprimer le modèle personnalisé',
  PERSONALIZED_MODEL_DELETE_CONFIRM: 'Êtes-vous sûr de vouloir supprimer ce modèle personnalisé ?',
  PERSONALIZED_MODEL_DELETE_SUCCESS: 'Modèle personnalisé supprimé avec succès',
  PERSONALIZED_MODEL_DELETE_ERROR: 'Erreur lors de la suppression du modèle personnalisé',
  PERSONALIZED_MODEL_LOAD_ERROR: 'Impossible de charger le modèle personnalisé',
  PERSONALIZED_MODEL_UNSAVED_CONFIRM: 'Des modifications non enregistrées seront perdues. Voulez-vous continuer ?',
  PERSONALIZED_MODEL_BADGE: 'Personnalisé',
  PERSONALIZED_MODEL_CARD_DESCRIPTION: 'Modèle créé par votre entreprise. Cliquez pour le prévisualiser.',
  PERSONALIZED_MODEL_ADD_DESCRIPTION: 'Créez un modèle réutilisable à partir de votre propre contenu.',
  PERSONALIZED_MODEL_LAST_UPDATED: 'Mis à jour le',
  PERSONALIZED_MODEL_USE: 'Utiliser',
  PERSONALIZED_MODEL_VIEW: 'Voir',
  PERSONALIZED_MODEL_EMPTY_TITLE: 'Aucun modèle personnalisé pour le moment',
  PERSONALIZED_MODEL_EMPTY_TEXT: 'Ajoutez un modèle personnalisé pour le visualiser, le modifier et le réutiliser dans la génération de documents.',
  FORMATIONMENU: 'Formation',
  FOLLOW: 'Suivre',
  PLAN: 'Plan',
  TEMPLATES: 'Modèles',
  DOCUMENT_TO_SIGN: 'Document à signer',
  URLNONVALIDE: 'URL non valide.',
  RECRUTEMENTTEXT1: "Logo de l'entreprise",
  RECRUTEMENTTEXT2: 'Vidéo de présentation',
  RECRUTEMENTTEXT3: "Description de l'entreprise",
  RECRUTEMENTTEXT4: 'Site web',
  RECRUTEMENTTEXT5: 'Mots-clés',
    RECRUTEMENTTEXT6: 'Bannière',
  RECRUTEMENTTEXT7: 'Autre',
  RECRUTEMENTTEXT8: 'Enregistrer',
  EMAIL_ACCEPTANCE_TEMPLATE: "Modèle d'email d'acceptation de candidature",
  CUSTOMIZE: 'Personnaliser',
  EMAIL_REJECTION_TEMPLATE: "Modèle d'email de rejet de candidature",
  EMAIL_INTERVIEW_INVITATION_TEMPLATE: "Modèle d'email d'invitation à un entretien",
  EMAIL_TEST_SUBMISSION_TEMPLATE: "Modèle d'email de soumission de test",
  PERSONALISERLIENACCES: "Personnaliser vos liens d'accès",
  MSGPERSONALISERACCES:
    "Ce champ vous permet de personnaliser l'URL du portail en choisissant un nom unique. Ce nom sera utilisé pour générer l'URL d'accès au portail. Veuillez utiliser uniquement des lettres, des chiffres et des tirets, sans espaces ni caractères spéciaux (/, &, ?, etc.) pour éviter d'altérer l'URL.",
  MENUTEST: 'Gestion des tests',
  IMPORT: {
    TITLE: 'Import de fichiers',
    TABLE: {
      DATE: "Date d'ajout",
      DESCRIPTION: 'Description',
      STATUS: 'Statut',
      NOM: 'Nom du fichier',
      PERIOD: 'Mois et année',
      AUTHOR: 'Importé par',
      NOT_APPLICABLE: '—',
      UNKNOWN_AUTHOR: 'Auteur indisponible',
    },
    STATUS: {
      EN_COURS: 'En cours',
      TERMINE: 'Terminé',
      ERREUR: 'Erreur',
      PARTIAL: 'Partiel',
      UNCERTAIN: 'À vérifier',
    },
    BUTTON: {
      IMPORT: 'Importer',
      EXTERNAL_API: 'Importer solde congé via API',
      PAIE_API: 'Importer paie via API',
      AUTO_PAIE: 'Import automatique paie',
      PAYROLL_FILE: 'Importer fichier paie',
      API_MENU: 'Importer via API',
      FILE_MENU: 'Importer via fichier',
    },
    MODE: {
      AUTO: 'Automatique',
      MANUAL: 'Manuel',
    },
    EXTERNAL_API_MODAL: {
      TITLE: 'Import depuis API externe',
      SELECT_API: 'Sélectionner une intégration',
      SELECT_API_PLACEHOLDER: 'Choisir une API...',
      SELECT_SITE: 'Sélectionner un site',
      SELECT_SITE_PLACEHOLDER: 'Choisir un site...',
      SELECT_MONTH: 'Mois',
      SELECT_YEAR: 'Année',
      MONTH_PLACEHOLDER: 'Choisir un mois...',
      YEAR_PLACEHOLDER: 'Choisir une année...',
      TRIGGER: 'Lancer l\'import',
      CANCEL: 'Annuler',
      SUCCESS: 'Import lancé avec succès',
      ERROR: 'Erreur lors du lancement de l\'import',
      NO_INTEGRATIONS: 'Aucune intégration compatible trouvée',
      VALIDATION_REQUIRED: 'Veuillez remplir tous les champs',
      CONFIRM_TITLE: 'Confirmer l\'import',
      CONFIRM_MESSAGE: 'Êtes-vous sûr de vouloir lancer l\'import des congés depuis l\'API externe ? Cette action va importer les soldes de congés.',
      MONTHS: {
        JANUARY: 'Janvier',
        FEBRUARY: 'Février',
        MARCH: 'Mars',
        APRIL: 'Avril',
        MAY: 'Mai',
        JUNE: 'Juin',
        JULY: 'Juillet',
        AUGUST: 'Août',
        SEPTEMBER: 'Septembre',
        OCTOBER: 'Octobre',
        NOVEMBER: 'Novembre',
        DECEMBER: 'Décembre',
      },
    },
    PAIE_API_MODAL: {
      TITLE: 'Import des lignes de paie via API',
      CONFIRM_TITLE: 'Confirmer l\'import de paie',
      CONFIRM_MESSAGE: 'Êtes-vous sûr de vouloir lancer l\'import des lignes de paie depuis l\'API externe ? Cette action va importer les bulletins de paie de la période sélectionnée.',
      SUCCESS: 'Import de paie lancé avec succès',
    },
    AUTO_PAIE_MODAL: {
      TITLE: 'Programmation de l\'import automatique de la paie',
      EXISTING_TITLE: 'Programmations existantes',
      NEW_TITLE: 'Nouvelle programmation',
      DAY_LABEL: 'Jour du mois',
      HOUR_LABEL: 'Heure',
      SELECT_MONTH: 'Mois des données à importer',
      SELECT_YEAR: 'Année des données à importer',
      HINT: 'L\'import sera déclenché automatiquement chaque mois, le jour et l\'heure sélectionnés. La période importée correspondra au mois de l\'exécution avec l\'année courante.',
      PERIODE_PREFIX: 'Données :',
      CREATE_BTN: 'Programmer',
      VALIDATION_REQUIRED: 'Veuillez remplir tous les champs',
      CREATE_SUCCESS: 'Programmation créée avec succès',
      CREATE_ERROR: 'Erreur lors de la création de la programmation',
      UPDATE_ERROR: 'Erreur lors de la mise à jour de la programmation',
      DELETE_TITLE: 'Supprimer la programmation',
      DELETE_MESSAGE: 'Êtes-vous sûr de vouloir supprimer cette programmation automatique ?',
      DELETE_SUCCESS: 'Programmation supprimée avec succès',
      DELETE_ERROR: 'Erreur lors de la suppression de la programmation',
      DELETE_BTN: 'Supprimer',
      STATUS_ACTIVE: 'Actif',
      STATUS_INACTIVE: 'Inactif',
      TOGGLE_HINT: 'Activer / désactiver la programmation automatique',
      NO_SCHEDULES: 'Aucune programmation automatique configurée',
      BACKEND_NOT_READY: 'La gestion des programmations automatiques n\'est pas encore disponible sur ce serveur.',
    },
    PAYROLL_FILE_HISTORY: 'Import fichier paie',
    // Payroll file review must explain each destructive operation before the user consents.
    PAYROLL_FILE: {
      TITLE: 'Importer un fichier de paie',
      EYEBROW: 'Import des données de paie',
      SUBTITLE: 'Analysez votre fichier, vérifiez les salariés et les rubriques proposés, puis confirmez la période et les valeurs à importer.',
      STEP_SOURCE: 'Fichier et période',
      STEP_MAPPING: 'Correspondances',
      STEP_REVIEW: 'Vérification et import',
      SOURCE_TITLE: 'Sélectionnez votre fichier',
      // File size is the sole business quota; parser and AI safety protections still apply.
      SOURCE_HINT: 'Un fichier CSV, XLS ou XLSX, jusqu’à 5 Mo. Aucun quota métier de lignes, rubriques ou valeurs. Lecture manuelle locale ; envoi au serveur uniquement si vous lancez l’analyse IA. Les protections techniques de lecture et d’analyse restent actives.',
      CHOOSE_FILE: 'Parcourir les fichiers',
      CHANGE_FILE: 'Changer de fichier',
      PERIOD_TITLE: 'Période de paie',
      PERIOD_HINT: 'Toutes les valeurs du fichier seront rattachées à ce mois.',
      READING_TITLE: 'Lecture du fichier',
      IDENTITY_TITLE: 'Identifier les salariés',
      IDENTITY_HINT: 'Associez les identifiants disponibles. Si le nom et le prénom partagent une colonne, conservez le nom complet.',
      MAPPING_TITLE: 'Associer les rubriques de paie',
      MAPPING_HINT: 'Faites correspondre chaque colonne de valeurs à une rubrique mensuelle. La recherche est intégrée aux listes.',
      REVIEW_TITLE: 'Vérifier avant d’importer',
      REVIEW_HINT: 'Contrôlez les associations, corrigez les valeurs et ignorez explicitement les lignes à exclure.',
      ROW_COUNT: '{{count}} ligne(s) dans l’aperçu',
      NO_WRITE_HINT: 'Aucune valeur de paie n’est écrite pendant la préparation.',
      FILE: 'Fichier Excel ou CSV',
      SHEET: 'Feuille',
      HEADER_ROW: "Ligne d'en-tête",
      ENCODING: 'Encodage CSV',
      SEPARATOR: 'Séparateur CSV',
      COMMA: 'Virgule',
      SEMICOLON: 'Point-virgule',
      TAB: 'Tabulation',
      NUMBER_FORMAT: 'Format des nombres',
      NUMBER_FR: 'Virgule décimale',
      NUMBER_EN: 'Point décimal',
      SOURCE_COLUMN: 'Colonne du fichier',
      SEARCH_SOURCE_COLUMN: 'Rechercher une colonne du fichier',
      PAYROLL_COLUMN: 'Rubrique de paie',
      SEARCH_PAYROLL_COLUMN: 'Rechercher une rubrique de paie',
      ADD_MAPPING: 'Ajouter une correspondance',
      REMOVE_MAPPING: 'Retirer la correspondance',
      OPTIONAL: 'Facultatif',
      LAST_NAME: 'Nom',
      NAME_OR_FULL_NAME: 'Nom ou nom complet',
      FULL_NAME: 'Nom et prénom dans une seule colonne',
      FIRST_NAME: 'Prénom',
      EMPLOYEE_NUMBER: 'Matricule',
      PROFESSIONAL_EMAIL: 'E-mail professionnel',
      SOCIAL_SECURITY_NUMBER: 'Numéro de sécurité sociale',
      SOURCE_ROW: 'Ligne du fichier',
      VALUE: 'Valeur',
      PREVIEW: 'Prévisualiser',
      SELECT_EMPLOYEE: 'Choisir le salarié',
      SEARCH_EMPLOYEE: 'Rechercher un salarié',
      SUGGESTIONS: 'Salariés suggérés pour ce nom',
      SUGGESTIONS_REQUIRE_REVIEW: 'Vérifiez le salarié avant de confirmer son association.',
      AUTO_MATCH_WARNING: 'Associé automatiquement au premier résultat par nom. Vérifiez cette identité avant l’import.',
      UNMAPPED_IDENTITY_REVIEW: 'Une autre colonne de cette ligne contient des données non associées : vérifiez les identifiants avant de choisir un salarié.',
      SEARCH_PAYROLL_FALLBACK: 'Rechercher aussi parmi les salariés sortis',
      SEARCH_PAYROLL_HINT: 'Pour retrouver un salarié sorti, essayez son nom seul ou son matricule.',
      MATCH_UNAVAILABLE: 'Suggestions par nom indisponibles. La recherche classique reste accessible.',
      NO_EMPLOYEE: 'Aucun salarié correspondant',
      NO_COLUMNS: 'Aucune rubrique mensuelle importable disponible',
      VALID: 'Validée',
      NEEDS_REVIEW: 'À corriger ou à ignorer',
      MANUAL_MATCH: 'Association manuelle',
      IGNORED: 'Ignorée',
      IGNORE: 'Ignorer',
      RESTORE_ROW: 'Réexaminer la ligne',
      INSERT_ROW: 'Insérer cette ligne',
      INSERT_ALL: 'Tout insérer',
      CLEANUP: 'Vider les données concernées avant d’insérer les nouvelles',
      BLOCKED_ROWS: 'Corrigez ou ignorez explicitement les {{count}} lignes en anomalie.',
      CONFIRM_TITLE: "Confirmer l'import de paie",
      CONFIRM_APPEND: 'Les données de {{period}} seront importées. Les anciennes données ne seront pas nettoyées. Les valeurs déjà présentes pour un salarié et une rubrique seront rejetées.',
      CONFIRM_CLEANUP: 'Pour {{period}}, seules les anciennes valeurs des salariés et rubriques des cellules à insérer seront supprimées. Les autres données seront conservées. Si une insertion échoue, les données supprimées ne seront pas restaurées.',
      PROGRESS: '{{done}} valeurs traitées sur {{total}}',
      STOP: "Arrêter après l'opération en cours",
      RESUME: 'Reprendre après validation',
      SUMMARY: "Bilan de l'import",
      SUCCEEDED_ROWS: 'Lignes entièrement insérées : {{count}}',
      REJECTED_ROWS: 'Lignes en échec ou partielles : {{count}}',
      PARTIAL_ROWS: 'Dont partiellement insérées : {{count}}',
      IGNORED_ROWS: 'Lignes ignorées : {{count}}',
      PENDING_ROWS: 'Lignes non traitées : {{count}}',
      ROW_INSERTED: 'Insérée',
      ROW_PARTIAL: 'Partiellement insérée',
      ROW_REJECTED: 'Rejetée',
      ROW_PENDING: 'Non traitée',
      ROW_UNCERTAIN: 'Résultat incertain',
      UNCERTAIN_ROWS: 'Lignes dont le résultat est à vérifier : {{count}}',
      INSERTED_VALUES: 'Valeurs insérées confirmées : {{count}}',
      DELETED_VALUES: 'Anciennes valeurs supprimées : {{count}}',
      DELETED_WITHOUT_INSERT: 'Données supprimées, nouvelle valeur non insérée. Aucune restauration automatique.',
      UNCERTAIN: 'Résultat incertain. Vérifiez dans Rémunération avant une nouvelle tentative.',
      CLOSE_WARNING: 'Les opérations exécutées seront conservées. Le bilan et le fichier ne seront pas mémorisés après fermeture.',
      AI: {
        EYEBROW: 'Analyse recommandée',
        TITLE: 'Comprendre la structure du fichier avec l’IA',
        // Proposed associations can be corrected directly without enabling a separate review mode.
        HINT: 'Lancez l’analyse pour identifier les salariés et proposer les rubriques, sans écrire de données de paie. Vérifiez les propositions et modifiez directement les correspondances si nécessaire.',
        IDENTITY_SUMMARY: 'Identifiants extraits automatiquement : matricule, e-mail professionnel et nom complet. Si le matricule est absent ou introuvable, la recherche examine les autres identifiants. Les conflits et doublons nécessitent une vérification manuelle.',
        IDENTIFYING: 'Recherche des salariés proposés à partir des identifiants source…',
        PROPOSED_EMPLOYEE: 'Salarié proposé, à vérifier',
        CONFIRM_EMPLOYEE: 'Confirmer ce salarié',
        IDENTITY_CONFIRMED: 'Choix confirmé pour cette source ; validation paie requise avant import.',
        IDENTITY_STATUS: {
          proposed: 'Correspondance proposée, non affectée automatiquement.',
          not_found: 'Aucune correspondance exacte : recherchez le salarié manuellement.',
          ambiguous: 'Plusieurs correspondances : aucune affectation automatique.',
          conflict: 'Identifiants contradictoires : aucune affectation automatique.',
          incomplete: 'Recherche incomplète ou indisponible : vérification manuelle requise.',
        },
        MATCHED_BY: { employee_number: 'Proposition par matricule exact', professional_email: 'Proposition par e-mail exact', full_name: 'Proposition par nom complet exact' },
        INSTRUCTIONS: 'Instructions et précisions pour l’analyse',
        ANALYZE: 'Analyser le fichier avec l’IA',
        EXPLICIT_RUN: 'Chaque clic envoie le fichier et lance une nouvelle analyse pouvant consommer des crédits IA.',
        SOURCE_PERIOD: 'Période identifiée dans la source :',
        SOURCE_MATRIX: 'Tous les salariés et toutes les valeurs de la source',
        SOURCE_MATRIX_HINT: 'Les valeurs source restent en lecture seule, sans somme implicite. Les propositions de salariés sont disponibles avant les unités et confirmations, même sans mois cible. Confirmez un salarié uniquement après vérification ; le contrôle paie reste obligatoire. Les colonnes TOTAL et exemples exclus figurent dans les régions exclues.',
        SOURCE_COUNTS: '{{employees}} salarié(s) source, {{groups}} groupe(s) de rubriques et {{values}} valeur(s), accessibles sur toutes les pages.',
        SOURCE_READONLY_BLOCKED: 'Toutes les valeurs extraites restent consultables. Les précisions demandées ou la période source inconnue bloquent uniquement l’application des choix et l’import.',
        SOURCE_EMPLOYEE: 'Salarié dans la source',
        SOURCE_ALIAS: 'Source n° {{id}}',
        SOURCE_CODE: 'Code de rubrique',
        SOURCE_SELECTED: 'Sélectionnée pour préparation, non autorisée à l’import',
        SOURCE_NOT_SELECTED: 'Non sélectionnée pour l’import',
        SOURCE_NO_VALUE: 'Aucune valeur source pour cette occurrence',
        SOURCE_EMPLOYEE_PAGES: 'Pages des salariés',
        SOURCE_GROUP_PAGES: 'Pages des rubriques',
        EXCLUDED_REGIONS: '{{count}} région(s) source explicitement exclue(s), dont les totaux globaux ou exemples identifiés',
        PERIOD: { single_month: 'Un mois', range: 'Cumul sur une période', unknown: 'Période inconnue' },
        RANGE_WARNING: 'La période source ne correspond pas à un seul mois cible. Les valeurs ne seront ni réparties ni proratisées. Leur rattachement à {{period}} exige votre accord explicite.',
        CUMULATIVE_CONSENT: 'J’accepte de rattacher ces valeurs cumulées de la période source au seul mois cible {{period}}.',
        QUESTIONS: 'Précisions demandées par l’analyse',
        REANALYZE_HINT: 'Ces points restent à vérifier. Une réponse ou une confirmation locale ne remplace pas les preuves du fichier ni les contrôles requis avant import.',
        CLARIFICATION_TITLE: 'Précisions nécessaires avant le résultat',
        CLARIFICATION_PENDING: 'L’analyse attend vos réponses. Ce n’est pas un résultat final : aucune recherche de salariés ni préparation d’import ne sera lancée avant une nouvelle analyse.',
        CLARIFICATION_REQUIRED: 'Répondez explicitement à chaque question : choisissez une option ou rédigez une réponse libre. Aucun choix n’est présélectionné.',
        CLARIFICATION_FREE: 'Autre / réponse libre',
        CLARIFICATION_ANSWER: 'Votre réponse',
        CLARIFICATION_LENGTH: 'Instructions, questions et réponses cumulées : {{count}} / {{limit}} caractères.',
        CLARIFICATION_TOO_LONG: 'La limite totale de {{limit}} caractères est dépassée. Raccourcissez vos réponses, ou modifiez les instructions pour recommencer sans l’historique des réponses. Aucun texte n’est tronqué et aucune demande n’est envoyée.',
        CLARIFICATION_HINT: 'Ce bouton renvoie le fichier original avec vos précisions et lance une nouvelle analyse pouvant consommer des crédits IA. Les réponses ne valent ni preuve source ni consentement à importer. Modifier le fichier ou les instructions efface les réponses de cette session.',
        CLARIFICATION_CONTINUE: 'Répondre et poursuivre',
        WARNINGS: 'Avertissements et rapprochements à vérifier',
        ACKNOWLEDGE: 'J’ai vérifié ces avertissements, rapprochements et régions exclues.',
        METRICS: 'Mesures à conserver',
        METRIC: { base: 'Base', salarial: 'Montant salarial', patronal: 'Montant patronal' },
        UNIT: 'Unité ou devise confirmée pour ce groupe (ex. EUR, heures, quantité, %)',
        UNIT_HINT: 'Repère facultatif d’unité ou de devise (ne confirme aucun groupe)',
        GROUP_UNITS_REQUIRED: 'Renseignez et vérifiez l’unité ou la devise de chaque groupe à importer. Un repère global ne remplace pas cette confirmation.',
        TOTALS: 'Sous-totaux et total brut',
        NO_AGGREGATION: 'Les détails, sous-totaux et totaux restent séparés. Ne les additionnez pas vers une même destination. Chaque groupe choisi exige sa propre rubrique cible.',
        SUBTOTALS: 'Inclure explicitement les sous-totaux',
        GROSS_TOTALS: 'Inclure explicitement les totaux bruts',
        KIND: { detail: 'Détail', subtotal: 'Sous-total', gross_total: 'Total brut' },
        EVIDENCE: 'Voir les {{count}} valeurs et références source',
        GROUP_COUNT: '{{count}} groupe(s) source visibles, y compris ceux ignorés, sans agrégation implicite',
        GROUP_INCLUDED: 'À importer après vérification et confirmation',
        GROUP_IGNORED: 'Ignoré pour l’import : aucune correspondance renseignée ou groupe non sélectionné',
        RESTORE_GROUP: 'Réexaminer ce groupe',
        EXCLUDED_COUNT: '{{count}} observation(s) exclue(s) explicitement',
        RESTORE_SOURCES: 'Réexaminer toutes les observations exclues',
        UNASSIGNED: 'Ignoré — choisir une destination',
        DESTINATION_HINT: 'Choisissez au moins une rubrique importable. Les rubriques non renseignées restent visibles et ignorées ; chaque rubrique retenue doit avoir une destination distincte.',
        TARGET_CONSENT: 'Je confirme séparément l’unité ou la devise et la destination des groupes à importer, sans double comptage des détails et totaux.',
        APPLY: 'Valider ces choix et vérifier la paie',
        IMMUTABLE_VALUES: 'Les valeurs de l’analyse restent celles relues dans la source. Pour corriger leur interprétation, relancez l’analyse ; elles ne sont pas modifiables dans l’aperçu.',
        FINAL_SELECTION: 'Les groupes et unités ci-dessous seront importés vers les destinations confirmées :',
        CONSENT_REQUIRED: 'Aucune écriture lancée : confirmez aussi le rattachement des cumuls au mois cible dans la confirmation finale.',
      },
      ERROR: {
        FILE: 'Fichier invalide, vide ou format non pris en charge.',
        // Agent read bounds need a distinct explanation from the upload-size limit.
        ANALYSIS_REGION: 'La plage de cellules demandée par l’agent est trop grande. Elle doit être lue par parties.',
        ANALYSIS_CONTEXT: 'Le contexte envoyé à l’IA dépasse le budget autorisé. Ce rejet ne concerne pas la taille du fichier.',
        ANALYSIS_BUDGET: 'L’analyse IA a atteint son budget cumulé. Aucun import n’a été effectué.',
        ANALYSIS_ITERATIONS: 'L’analyse IA a atteint sa limite d’appels avant de pouvoir être finalisée. Aucun import n’a été effectué.',
        ANALYSIS_EXCLUSIONS: 'Les exclusions de totaux ou d’exemples proposées par l’IA ne sont pas suffisamment prouvées par le fichier. Aucun import n’a été effectué.',
        LIMIT: 'Le fichier dépasse 5 Mo ou le traitement a atteint une protection technique de lecture ou d’analyse. Aucun quota métier de lignes, rubriques ou valeurs n’est appliqué.',
        MAPPING: 'Vérifiez la période et les correspondances de colonnes.',
        IDENTITY: 'Salarié absent, ambigu ou identifiants contradictoires. Choisissez le salarié.',
        REFERENCE: 'Référence introuvable ou non disponible.',
        COLUMN: "Cette rubrique n'est pas mensuelle directement importable.",
        VALUE: "Valeur invalide. Aucune conversion implicite n'est effectuée.",
        FILE_DUPLICATE: 'Plusieurs lignes visent le même salarié, la même rubrique et le même mois.',
        EXISTING_VALUE: 'Une valeur existe déjà pour ce salarié, cette rubrique et ce mois.',
        NO_VALUE: "Cette ligne ne contient aucune valeur à insérer.",
        ACCESS: "L'import est réservé aux administrateurs disposant du privilège administrateur paie.",
        ENCRYPTION: "Le chiffrement de la paie est indisponible. Aucune écriture ne sera lancée.",
        SERVICE: "La préparation de l'import est indisponible.",
        HISTORY_START_FAILED: "Impossible d'ouvrir l'historique de l'import. Aucune écriture de paie n'a été lancée.",
        HISTORY_UPDATE_FAILED: "L'historique de l'import n'a pas pu être confirmé. Les données de paie déjà traitées restent actives ; vérifiez le bilan avant de fermer.",
      },
    },
  },
  MOTCLEINFO:
    'Ajoutez des mots-clés représentatifs (tags) pour votre entreprise (ex : informatique, start-up, secteur financier, innovation, télétravail). Ces mots-clés aideront à mieux identifier et catégoriser votre entreprise.',
  DETAILS: 'Détails',
  SOUSCRIREMAINTENANT: 'Souscrire maintenant',
  SOUSCRIREABONNEMENT: 'Souscrire à un abonnement',
  TEXTABONNEMENT0: 'à une de nos formules',
  TEXTABONNEMENT1: "Il semble que vous n'ayez pas d'abonnement actif. Souscrivez dès maintenant ",
  TEXTABONNEMENT2: "pour débloquer l'accès à tous nos modules et fonctionnalités exclusives.",
  PERONALISERPARAMETRE:
    'Personnalisez votre plateforme en activant ou désactivant vos modules ici, selon votre abonnement et vos besoins.',
  REFRESHAPPLICATION: 'Actualisez pour appliquer les modifications.',
  LOGIN_MFA_SETTING_TITLE: 'Authentification multifacteur',
  LOGIN_MFA_SETTING_DESCRIPTION:
    "Un code de vérification est envoyé à l'adresse e-mail de l'utilisateur lorsqu'il tente de se connecter, sauf si cette fonctionnalité est désactivée.",
  LOGIN_MFA_SETTING_ENABLED: 'Activée',
  MOBILE_DEVICE_WHITELIST_SETTING_TITLE: 'Liste blanche des appareils mobiles',
  MOBILE_DEVICE_WHITELIST_SETTING_DESCRIPTION:
    "Lorsqu’elle est activée, seuls les appareils actifs enregistrés dans Matériel, affectés à l’utilisateur et autorisés individuellement peuvent se connecter via l’application mobile. La connexion au site web n’est pas affectée.",
  MOBILE_DEVICE_WHITELIST_SETTING_ENABLED: 'Activée',
  SECURITY_PAGE_TITLE: "Sécurité de l’entreprise",
  SECURITY_SECTION_EYEBROW: 'Paramètres de sécurité',
  SECURITY_SECTION_TITLE: 'Authentification et accès',
  SECURITY_SECTION_DESCRIPTION: "Configurez l’authentification et l’accès mobile des comptes collaborateurs.",
  SECURITY_LOADING: 'Chargement des paramètres de sécurité',
  SECURITY_SAVING: 'Enregistrement...',
  SECURITY_LOAD_ERROR: "Impossible de charger les paramètres de sécurité de l’entreprise.",
  SECURITY_SAVE_SUCCESS: 'Les paramètres de sécurité ont été mis à jour.',
  SECURITY_SAVE_ERROR: 'Impossible de mettre à jour les paramètres de sécurité.',
  VOTRECREDITIA: 'Vos Crédits IA',
  VOTRECREDITSIGNATURE: 'Vos Crédits Signature',
  CREDITS: 'Crédits',
  MSGTITRESUGGESTION:
    "Ce sont des candidats existants dans la CVthèque qui sont éligibles pour cette offre d'emploi mais qui n'ont pas postulé",
  ECHECOPERATION: 'Opération échouée. Veuillez réessayer.',
  LIGNEINSERE: 'Ligne insérée',
  LIGNEREJETER: 'Ligne rejetée',
  MODETRAVAIL: 'Mode de travail',
  LOISIRS: 'Loisirs',
  SITE: 'Site',
  SERVICE: 'Service',

  // Clés pour l'autocomplétion des villes
  CITY: {
    SELECT_CITY: 'Sélectionner une ville',
    SEARCH_ERROR: 'Erreur lors de la recherche des villes',
    NO_RESULTS: 'Aucune ville trouvée',
    TYPE_TO_SEARCH: 'Tapez pour rechercher une ville',
  },
  TELEPHONEPRO: 'Téléphone professionnel',
  COMPETENCESPRES: 'Compétences',
  MSGPRES1: 'Ouvrir le chat',
  MSGPRES2: 'Suggérer un rendez-vous',

  AUCUNVIDEO: "Aucune vidéo n'est disponible pour le moment. Veuillez vérifier ultérieurement.",
  AUCUNPRESENTATION: "Aucune description n'est disponible pour le moment.",
  PRESENTATION: 'Présentation',
  CONTRAT: 'Contrat',
  DATEDEBUTCONTRAT: 'Date de début de contrat',
  DATEFINCONTRAT: 'Date de fin de contrat',
  DATEENTREEGROUPE: "Date d'entrée dans le groupe",
  FILTER: 'Filtrer',
  NO_RESULTS: 'Aucun résultat trouvé',
  AUCUNMANAGER: 'Aucun manager trouvé',
  AUCUNMANAGER_SELECTIONNE: 'Aucun manager sélectionné',

  EQUIPE: 'Équipe',

  SELECTIONNEREQUIPE: 'Sélectionner une équipe',
  SELECTIONNERSITE: 'Sélectionner un site',
  FILTREREQUIPE: 'Filtrer les équipes',
  FILTRERSITE: 'Filtrer les sites',
  AUCUNEEQUIPETROUVEE: 'Aucune équipe trouvée',
  AUCUNSITETROUVE: 'Aucun site trouvé',

  MSGEQUIPEINFO:
    'Si vous n\'avez pas encore créé vos équipes, vous pouvez affecter ce collaborateur à l\'option "Non assigné". Une fois vos équipes créées, vous pourrez facilement affecter ce collaborateur à la bonne équipe.',
  REFUSCANDIDAT: 'Refuser le candidat',
  COPIER: 'Copier',
  COPIEREMAIL: "Copier l'adresse email",
  COPIEEMAILSUCCESS: 'Email copié avec succès',
  EMAIL_COPIED: 'Email copié avec succès',
  MESSAGE_COPIED: 'Message copié avec succès',
  COPY_ERROR: 'Erreur lors de la copie',
  SKILLS: 'Compétences',
  COPIEQUESTIONS: 'Copier les questions',
  COPIEQUESTIONSSUCCESS: 'Questions copiées avec succès',
  FERMER: 'Fermer',
  SUGGESTIONQUESTIONS: 'Voici une suggestion de 10 questions :',
  QUESTIONSPOSERLORSENTRETIEN: "Questions suggérées à poser aux candidats lors de l'entretien",
  ASSIGNEROFFRE: 'Assigner à une offre',
  EFFECTUERACTION: 'Effectuer une action',
  AUTRESCANDIDATS: 'Autres candidats',
  CANDIDATS: 'Candidats',
  BACK: 'Retour',
  TRIERPARDATE: 'Trier par date',
  PLUSRECENT: 'Plus récent',
  PLUSANCIEN: 'Plus ancien',

  AUCUNCANDIDATTROUVE: "Actuellement, aucun candidat n'a été trouvé.",
  VOICIQUESTION: 'Voici une suggestion des questions :',

  // Clés pour l'infobulle des candidats dans le Kanban
  PHOTOPROFIL: 'Photo de profil',
  RESUMECV: 'Résumé du CV',
  HISTORIQUE: 'Historique',
  // Libellés de la comparaison détaillée des versions du profil utilisateur.
  USER_HISTORY: {
    TITLE: 'Historique des modifications',
    LOADING: 'Chargement de l’historique…',
    LOAD_ERROR: 'Impossible de charger l’historique des modifications.',
    EMPTY: 'Aucune modification enregistrée.',
    SYSTEM: 'Système',
    OLD_VALUE: 'Ancienne valeur',
    NEW_VALUE: 'Nouvelle valeur',
    FIELDS: {
      prenom: 'Prénom',
      nom: 'Nom',
      photo_principale: 'Photo de profil',
      date_entre: 'Date d’entrée',
      fonction: 'Fonction',
      date_fin: 'Date de sortie',
      nouvelle_recrue: 'Nouvelle recrue',
      idequipe: 'Équipe',
      date_naissance: 'Date de naissance',
      genre: 'Genre',
      mail_personnel: 'E-mail personnel',
      user_langue: 'Langue',
      pays_user: 'Pays',
      ville_user: 'Ville',
      adresse_user: 'Adresse',
      code_postal: 'Code postal',
      telephone: 'Téléphone personnel',
      lien_linkedin: 'Profil LinkedIn',
      num_securite_social: 'Numéro de sécurité sociale',
      num_passport: 'Numéro de passeport',
      cin: 'Numéro de pièce d’identité',
      nationalite: 'Nationalité',
      user_contact_urgence: 'Contact d’urgence',
      relation_user_urgence: 'Lien avec le contact d’urgence',
      phone_user_urgence: 'Téléphone du contact d’urgence',
      adresse_user_urgence: 'Adresse du contact d’urgence',
      uuid_manager: 'Manager',
      telephone_professionel: 'Téléphone professionnel',
      situation_familiale: 'Situation familiale',
      lieu_naissance: 'Lieu de naissance',
      identite_verso: 'Pièce d’identité (verso)',
      identite_recto: 'Pièce d’identité (recto)',
      num_enfants: 'Nombre d’enfants',
      complement_adress: 'Complément d’adresse',
      qualification: 'Qualification',
      date_autorisation_embauche: 'Date d’autorisation d’embauche',
      date_autorisation_licenciement: 'Date d’autorisation de licenciement',
      departement_naissance: 'Département de naissance',
      date_entree_groupe: 'Date d’entrée dans le groupe',
    },
  },
  RESEAUXSOCIAUX: 'Réseaux sociaux',
  CVSOUMIS: 'Ce CV a été soumis pour le poste de',
  PASPOSTEAPPLIQUE: 'Aucun poste appliqué',
  COMPTERENDUCV: 'Compte rendu du CV',
  APROPOS: 'À propos du candidat',
  NOMPRENOM: 'Nom complet',
  NATIONALITE: 'Nationalité',
  DATENAISSANCE: 'Date de naissance',
  ADRESSE: 'Adresse',
  EMAIL: 'Email',
  NUMTELEPHONE: 'Numéro de téléphone',
  NOM: 'Nom',
  PRENOM: 'Prénom',
  CORRESPONDANCEAVEC: 'Correspondance avec le poste',
  // RELANCERANALYSE: "Relancer l'analyse par critères de sélection",
  // LANCERANALYSE: "Lancer l'analyse par critères de sélection",
  RELANCERANALYSE: "Relancer l'analyse",
  LANCERANALYSE: "Lancer l'analyse",
  OFFREEMPLOI: "Offre d'emploi",
  ANALYSE: 'Analyse',
  CANDIDATNECORRESPONDPAS: "Le candidat ne correspond pas aux critères de sélection de l'offre d'emploi.",
  ANALYSEPOUSSE: "L'analyse poussée par IA est disponible uniquement pour le candidat rattaché à l'offre.",
  QUESTIONSSUGGEREES: 'Questions suggérées',
  COMPETENCES: 'Ses compétences',
  POSTESUGGERES: 'Postes suggérés',
  PASPOSTESUGGERE: 'Pas de postes suggérés',
  NOTES: 'Notes',
  EXPERIENCE: 'Expérience',
  FORMATION: 'Formation',
  CERTIFICATIONS: 'Certifications',
  LESDOCUMENTSDECANDIDAT: 'Documents du candidat',
  AJOUTERUNDOCUMENT: 'Ajouter un document',
  PROCESSUSDERECRUTEMENT: 'Processus de recrutement',
  ASSIGNERcetteoffre: 'Assigner à cette offre',
  SUGGERERCANDIDAT: 'Suggérer des candidats',
  LISTECANDIDATSSUGGERER: 'Liste des candidats suggérés',
  MESCANDIDATS: 'Mes candidats',
  CANDIDATDEJAASSIGNE: 'Ce candidat est déjà assigné à cette offre',
  CANDIDATNONASSIGNE: 'Assigner ce candidat à cette offre',
  RENSEIGNERFROMDOCUMENT: "Renseigner à partir d'un document",
  INFOPERSONELLE: 'Informations personnelles',
  LIEUNAISSANCE: 'Lieu de naissance',
  CODEPOSTAL: 'Code postal',
  COMPLEMENTADRESSE: "Complément d'adresse",
  COORDONNEES: 'Coordonnées',
  DOCUMENTIDENTITEVERSO: "Document d'identité verso",
  DOCUMENTIDENTITERECTO: "Document d'identité recto",
  DOCUMENTSIDENTITE: "Documents d'identité",
  NUMEROSECUSOCIALE: 'Numéro de sécurité sociale',
  CODESIGLE: 'Code Sigle',
  ID_TYPE: "Pièces d'identité",
  VILLE: 'Ville',
  VOIRDOCEXISTANT: 'Voir document existant',
  REINITIALISER: 'Réinitialiser',
  AUTORISATIONSADMINISTRATIVES: 'Autorisations Administratives',
  MANAGER: 'Manager',
  EMPLOIETPOSITION: 'Emploi et Position',
  NOMDUCONTACTURGENT: "Nom du contact d'urgence",
  NUMERODUCONTACTURGENT: "Numéro du contact d'urgence",
  NOMBREDENFANTS: "Nombre d'enfants",
  VEUF: 'Veuf(ve)',
  DIVORCE: 'Divorcé(e)',
  MARIE: 'Marié(e)',
  PACSE: 'Pacsé(e)',
  CELIBATAIRE: 'Célibataire',
  NON_RENSEIGNEE: 'Non renseignée',
  SITUATIONFAMILIALE: 'Situation Familiale',
  SITUATIONFAMILIALEETURGENCE: 'Situation Familiale et Urgence',
  RELATIONCONTACTURGENCE: "Relation Contact d'Urgence",
  TELEPHONEPERSONNEL: 'Téléphone Personnel',
  TELEPHONEPROFESSIONNEL: 'Téléphone Professionnel',
  GENRE: 'Genre',
  HOMME: 'Homme',
  FEMME: 'Femme',
  AUTRE: 'Autre',
  INVALID_FILE_TYPE: 'Type de fichier invalide. Veuillez télécharger un fichier .xls ou .xlsx.',
  VEUUILERIMPORTER: 'Veuillez importer un fichier',

  // Clés ajoutées pour harmonisation avec en.ts
  ADDRESS: 'Adresse',
  YES: 'Oui',
  NO: 'Non',
  FROM: 'De',
  TO: 'À',
  HEIGHT: 'Hauteur',
  WIDTH: 'Largeur',
  COLOR: 'Couleur',
  LEGAL_MODAL: {
    DEFAULT_HEADER: "Conditions d'utilisation",
    NO_CONTENT: 'Aucun contenu disponible.',
    ACCEPT_TERMS: "J'accepte les conditions d'utilisation",
    TERMS_REQUIRED: "Vous devez accepter les conditions d'utilisation pour continuer.",
    ACCEPT_BUTTON: "J'accepte",
    ERROR_LOADING: "Erreur lors du chargement des conditions d'utilisation",
    ACCEPTANCE_SAVED: 'Votre acceptation a été enregistrée avec succès',
    ERROR_SAVING: "Erreur lors de l'enregistrement de votre acceptation",
    NO_DATA: 'Aucune condition légale trouvée.',
    SELECT_LANGUAGE: 'Langue :',
  },
  ERRORS: {
    OCCURED_TRY_AGAIN: 'Une erreur est survenue, veuillez réessayer !',
    AI_QUOTA_EXCEEDED: 'Votre quota IA est dépassé. Contactez-nous pour demander une augmentation.',
  },
  VIEW: 'Voir',
  SEND: 'Envoyer',
  PREVIEW: 'Aperçu',
  DOWNLOAD: 'Télécharger',
  DELETE: 'Supprimer',
  CREATE: 'Créer',
  CLOSE: 'Fermer',
  CONFIRM: 'Confirmer',
  ASSIGN: 'Assigner',
  FIND_USER: 'Trouver un collaborateur',
  FIND_USERS: 'Trouver des collaborateurs',
  MONTHS: {
    1: 'Janvier',
    2: 'Février',
    3: 'Mars',
    4: 'Avril',
    5: 'Mai',
    6: 'Juin',
    7: 'Juillet',
    8: 'Août',
    9: 'Septembre',
    10: 'Octobre',
    11: 'Novembre',
    12: 'Décembre',
  },
  // Clés pour la configuration d'emails
  EMAIL_CONFIG: 'Configuration des emails :',
  PERSONAL_MAILBOX: 'Boîte mail personnelle',
  EMYEHR_DEDICATED_BOX: 'Boîte dédiée EmyeHR',
  PERSONAL_MAILBOX_DESC: 'Les emails ne sont pas reçus par EmyeHR. Ils ne seront pas visibles dans l\'ATS.',
  EMYEHR_DEDICATED_BOX_DESC: 'Envoi recommandé : Les emails envoyés depuis cette boîte sont reçus et automatiquement synchronisés dans EmyeHR (ATS).',
  // Clés pour l'audio
  AUDIO_BUTTON: 'Send audio message',
  MICROPHONE_ERROR: 'Error accessing microphone',
  AUDIO_PROCESS_ERROR: 'Error processing audio',
  REALTIME_AUDIO_START: 'Start real-time audio',
  REALTIME_AUDIO_STOP: 'Stop real-time audio',
  REALTIME_AUDIO_INDICATOR: "Live audio: speak naturally, I'll respond when you pause",
  REALTIME_AUDIO_START_ERROR: 'Erreur lors du démarrage de l\'audio en temps réel',
  REALTIME_AUDIO_CONNECTION_LOST: 'Connexion audio temps réel interrompue',
  REALTIME_TRANSCRIPTION_LOCAL: 'Transcription locale',
  REALTIME_TRANSCRIPTION_SERVER: 'Transcription serveur',
  LAST_RESPONSE: 'Dernière réponse',
  FILE: 'Fichier',
  UPLOADED_BY: 'Téléchargé par',
  NO_DATA: 'Aucune donnée disponible',
  CONFIRM_DELETE: 'Confirmer la suppression',
  TYPE_TO_CONFIRM_WARNING: 'Cette action est irréversible et supprimera définitivement cet élément.',
  TYPE_TO_CONFIRM_LABEL: 'Pour confirmer, veuillez taper',
  // Clés pour l'export via API externe
  PAYROLL_EXPORT: {
    EXTERNAL_API: {
      BUTTON: 'Export via l\'API',
      TITLE: 'Export via l\'API',
      SELECT_API: 'Sélectionner une API',
      SELECT_API_PLACEHOLDER: 'Choisir une API...',
      NO_INTEGRATIONS: 'Aucune intégration disponible',
      SELECT_SITE: 'Sélectionner un site',
      SELECT_SITE_PLACEHOLDER: 'Choisir un site...',
      START_DATE: 'Date de début',
      END_DATE: 'Date de fin',
      CANCEL: 'Annuler',
      TRIGGER: 'Lancer l\'export',
      SUCCESS: 'L\'export a été déclenché avec succès',
      ERROR: 'Une erreur est survenue lors de l\'export',
      VALIDATION_REQUIRED: 'Veuillez remplir tous les champs obligatoires',
      CONFIRM_TITLE: 'Confirmer l\'export',
      CONFIRM_MESSAGE: 'Êtes-vous sûr de vouloir lancer l\'export via l\'API ? Les données de congés seront envoyées vers l\'API externe.',
    },
  },
  SHARE: {
    EYEBROW: 'Réseaux sociaux',
    BTN_TITLE: "Partager l'offre",
    MODAL_TITLE: "Partager l'offre sur les réseaux sociaux",
    LINK_ATTACHED: "Voir les détails de l’offre sur le portail",
    INSTRUCTIONS_LABEL: 'Avez-vous des instructions supplémentaires pour la rédaction du post ? (facultatif)',
    INSTRUCTIONS_PLACEHOLDER: 'Ex : rends le post plus dynamique, cible des profils juniors, mets en avant le télétravail...',
    WRITE_YOUR_POST: 'Rédigez votre propre post',
    WRITE_PLACEHOLDER: 'Écrivez votre message de partage ici...',
    ASK_AI: "Demander à l'IA de rédiger",
    AI_PLACEHOLDER: 'Ex : poste attractif pour un développeur senior en télétravail...',
    GENERATE_AI: "Générer avec l'IA",
    GENERATE_AI_PHOTO: 'Générer le post',
    GENERATE_HINT: 'Texte + visuel préparés par Emye',
    POST_READY: 'Publication générée',
    REGENERATE_PUBLICATION: 'Régénérer',
    GENERATE_ERROR: 'Erreur lors de la génération du post. Veuillez réessayer.',
    GENERATE_IMAGE_ERROR: "Erreur lors de la génération de l'image. Veuillez réessayer.",
    SAVE_ERROR: 'Erreur lors de la sauvegarde du post. Veuillez réessayer.',
    CUSTOMIZE_AI_MESSAGE: 'Vérifiez le résultat',
    CUSTOMIZE_PLACEHOLDER: "Le message généré par l'IA s'affichera ici et restera modifiable...",
    PREVIEW: 'Aperçu du post',
    IMAGE_ALT: "Image générée pour l'offre d'emploi",
    IMAGE_PLACEHOLDER: "L'image générée apparaîtra ici",
    PREVIEW_TEXT_PLACEHOLDER: "Le texte de la publication apparaîtra ici après génération.",
    REFRESH_IMAGE: 'Régénérer une nouvelle image',
    REFRESHING_IMAGE: 'Génération...',
    DOWNLOAD_IMAGE: "Télécharger l'image",
    IMAGE_DOWNLOADED: 'Image téléchargée.',
    IMAGE_PREVIEW_OPEN: "Agrandir l'image générée",
    IMAGE_PREVIEW_CLOSE: "Fermer l'aperçu de l'image",
    SHARE_ON: 'Partager sur',
    CHOOSE_NETWORK: 'Choisissez le réseau à préparer',
    NETWORK_LINKEDIN: 'LinkedIn',
    NETWORK_FACEBOOK: 'Facebook',
    NETWORK_X: 'X (Twitter)',
    NETWORK_INDEED: 'Indeed',
    NETWORK_INSTAGRAM: 'Instagram',
    NETWORK_TIKTOK: 'TikTok',
    GUIDE_EYEBROW: 'Assistant guidé',
    GUIDE_TITLE: 'Votre publication est prête à être préparée',
    GUIDE_SUBTITLE: 'Emye prépare le texte, le visuel et le lien de votre offre. Vous gardez la main pour vérifier et publier sur le réseau choisi.',
    GUIDE_STEP_1_TITLE: 'Choisissez le réseau',
    GUIDE_STEP_1_TEXT: 'Cliquez sur le réseau où vous souhaitez publier.',
    GUIDE_STEP_2_TITLE: 'Emye prépare le contenu',
    GUIDE_STEP_2_TEXT: 'Le texte est copié et le visuel est prêt.',
    GUIDE_STEP_3_TITLE: 'Le réseau s’ouvre',
    GUIDE_STEP_3_TEXT: 'Le site choisi s’ouvre dans un nouvel onglet.',
    GUIDE_STEP_4_TITLE: 'Collez le texte',
    GUIDE_STEP_4_TEXT: 'Cliquez dans la zone de publication et faites Ctrl + V.',
    GUIDE_STEP_5_TITLE: 'Vérifiez et publiez',
    GUIDE_STEP_5_TEXT: 'Relisez, ajoutez le visuel si besoin, puis publiez.',
    PREPARE_FOR: 'Préparer pour',
    PREPARE_DESCRIPTION_LINKEDIN: 'Texte copié + visuel à importer',
    PREPARE_DESCRIPTION_FACEBOOK: 'Texte copié + visuel à importer',
    PREPARE_DESCRIPTION_X: 'Texte court, sans lien visible',
    PREPARE_DESCRIPTION_INDEED: "Texte de l'offre copié",
    PREPARE_DESCRIPTION_INSTAGRAM: 'Texte copié + visuel prêt',
    PREPARE_DESCRIPTION_TIKTOK: 'Texte copié + visuel à télécharger',
    NETWORK_HELP: 'Cliquez sur un réseau : le texte et le lien seront copiés, puis le site s’ouvrira. Téléchargez le visuel pour l’ajouter manuellement.',
    NEXT_STEPS_EYEBROW: 'À faire maintenant',
    FOLLOW_NETWORK_GUIDE: 'Suivez le guide du réseau choisi',
    NETWORK_GUIDE_TITLE: 'Publication {{network}} prête',
    NETWORK_GUIDE_SUBTITLE_LINKEDIN: 'Créez un post normal : collez le lien pour générer l’aperçu. Une fois l’aperçu affiché, vous pouvez retirer le lien du texte pour garder un post plus propre.',
    NETWORK_GUIDE_SUBTITLE_FACEBOOK: 'Créez un post normal : collez le lien pour générer l’aperçu. Une fois l’aperçu affiché, vous pouvez retirer le lien du texte pour garder un post plus propre.',
    NETWORK_GUIDE_SUBTITLE_X: 'Le texte est généré pour respecter la limite de X. Aucun lien visible n’est ajouté au post.',
    NETWORK_GUIDE_SUBTITLE_INDEED: 'Le texte est copié pour vous aider à compléter ou créer votre annonce Indeed.',
    NETWORK_GUIDE_SUBTITLE_INSTAGRAM: 'Le texte est copié et le visuel est prêt à être téléchargé puis importé dans Instagram.',
    NETWORK_GUIDE_SUBTITLE_TIKTOK: 'Pour l’instant, téléchargez le visuel. La vidéo TikTok pourra être générée ensuite à partir de cette image.',
    PREPARED_TEXT_COPIED: 'Texte copié',
    PREPARED_TEXT_LINK_COPIED: 'Texte et lien copiés',
    PREPARED_TEXT_PREFILLED: 'Texte prérempli',
    PREPARED_X_TEXT_READY: 'Texte X prêt et raccourci',
    PREPARED_NO_VISIBLE_LINK: 'Aucun lien visible ajouté',
    PREPARED_LINK_READY: 'Détails de l’offre disponibles sur le portail',
    PREPARED_IMAGE_DOWNLOADED: 'Visuel téléchargé',
    PREPARED_IMAGE_TO_DOWNLOAD: 'Visuel à télécharger',
    PREPARED_NETWORK_OPENED: 'Site ouvert',
    PREPARED_NETWORK_READY_TO_OPEN: 'Site prêt à ouvrir',
    NETWORK_GUIDE_STEP_LINKEDIN_1: 'Cliquez sur “Ouvrir LinkedIn”.',
    NETWORK_GUIDE_STEP_LINKEDIN_2: 'Dans LinkedIn, cliquez sur “Commencer un post”.',
    NETWORK_GUIDE_STEP_LINKEDIN_3: 'Cliquez sur “Copier le lien”, collez-le pour générer l’aperçu. Une fois l’aperçu affiché, vous pouvez retirer le lien du texte pour garder un post plus propre.',
    NETWORK_GUIDE_STEP_LINKEDIN_4: 'Cliquez sur “Recopier le texte”, collez-le, puis ajoutez le visuel téléchargé.',
    NETWORK_GUIDE_STEP_LINKEDIN_5: 'Relisez, puis publiez.',
    NETWORK_GUIDE_STEP_FACEBOOK_1: 'Cliquez sur “Ouvrir Facebook”.',
    NETWORK_GUIDE_STEP_FACEBOOK_2: 'Dans Facebook, créez une publication normale.',
    NETWORK_GUIDE_STEP_FACEBOOK_3: 'Cliquez sur “Copier le lien”, collez-le pour générer l’aperçu. Une fois l’aperçu affiché, vous pouvez retirer le lien du texte pour garder un post plus propre.',
    NETWORK_GUIDE_STEP_FACEBOOK_4: 'Cliquez sur “Recopier le texte”, collez-le, puis ajoutez le visuel téléchargé.',
    NETWORK_GUIDE_STEP_FACEBOOK_5: 'Relisez, puis publiez.',
    NETWORK_GUIDE_STEP_X_1: 'Cliquez sur “Ouvrir X”.',
    NETWORK_GUIDE_STEP_X_2: 'X s’ouvre avec un texte raccourci, sans lien visible.',
    NETWORK_GUIDE_STEP_X_3: 'Si vous voulez ajouter l’image, téléchargez le visuel puis choisissez-le avec l’icône média.',
    NETWORK_GUIDE_STEP_X_4: 'Relisez, puis publiez.',
    NETWORK_GUIDE_STEP_INDEED_1: 'Cliquez sur “Ouvrir Indeed”.',
    NETWORK_GUIDE_STEP_INDEED_2: 'Ouvrez ou créez l’annonce concernée.',
    NETWORK_GUIDE_STEP_INDEED_3: 'Collez le texte avec Ctrl + V dans la description.',
    NETWORK_GUIDE_STEP_INDEED_4: 'Vérifiez les informations, puis enregistrez ou publiez.',
    NETWORK_GUIDE_STEP_INSTAGRAM_1: 'Cliquez sur “Ouvrir Instagram”.',
    NETWORK_GUIDE_STEP_INSTAGRAM_2: 'Créez une nouvelle publication.',
    NETWORK_GUIDE_STEP_INSTAGRAM_3: 'Téléchargez le visuel si ce n’est pas déjà fait, puis choisissez-le dans Instagram.',
    NETWORK_GUIDE_STEP_INSTAGRAM_4: 'Collez le texte avec Ctrl + V dans la description.',
    NETWORK_GUIDE_STEP_INSTAGRAM_5: 'Relisez, puis publiez.',
    NETWORK_GUIDE_STEP_TIKTOK_1: 'Cliquez sur “Ouvrir TikTok”.',
    NETWORK_GUIDE_STEP_TIKTOK_2: 'Créez la publication depuis TikTok Web ou l’application mobile.',
    NETWORK_GUIDE_STEP_TIKTOK_3: 'Téléchargez le visuel si ce n’est pas déjà fait. La version vidéo sera ajoutée dans une prochaine étape.',
    NETWORK_GUIDE_STEP_TIKTOK_4: 'Collez le texte avec Ctrl + V, puis publiez.',
    ASSISTANT_EYEBROW: 'Assistant Emye',
    COMPACT_STEP_1_TITLE: 'Générez votre publication',
    COMPACT_STEP_2_TITLE: 'Choisissez un réseau',
    COMPACT_STEP_3_TITLE: 'Emye vous guide jusqu’à la publication',
    ASSISTANT_TITLE: 'Votre post {{network}} est prêt',
    ASSISTANT_SUBTITLE: 'Suivez les étapes ci-dessous pour finaliser votre publication sans vous perdre.',
    ASSISTANT_LAST_STEP: 'Étapes à suivre :',
    ASSISTANT_CHECK_TEXT_COPIED: 'Texte copié automatiquement',
    ASSISTANT_CHECK_TEXT_LINK_COPIED: 'Texte et lien copiés automatiquement',
    ASSISTANT_CHECK_VISUAL_READY: 'Visuel prêt',
    ASSISTANT_CHECK_IMAGE_READY: 'Image prête',
    ASSISTANT_CHECK_LINK_READY: "Détails de l'offre disponibles sur le portail",
    ASSISTANT_CHECK_TEXT_LINK_PREFILLED: 'Texte + lien préremplis',
    ASSISTANT_CHECK_LINKEDIN_OPENED: 'LinkedIn ouvert',
    ASSISTANT_CHECK_FACEBOOK_OPENED: 'Facebook ouvert',
    ASSISTANT_CHECK_X_OPENED: 'X ouvert',
    ASSISTANT_CHECK_INDEED_OPENED: 'Indeed ouvert',
    ASSISTANT_CHECK_INSTAGRAM_OPENED: 'Instagram ouvert',
    ASSISTANT_CHECK_TIKTOK_OPENED: 'TikTok ouvert',
    ASSISTANT_STEP_LINKEDIN_1: 'LinkedIn vient de s’ouvrir dans un nouvel onglet.',
    ASSISTANT_STEP_LINKEDIN_2: 'Cliquez sur “Commencer un post”.',
    ASSISTANT_STEP_LINKEDIN_3: 'Appuyez sur Ctrl + V pour coller le texte et le lien préparés par Emye.',
    ASSISTANT_STEP_LINKEDIN_4: 'Cliquez sur l’icône photo et importez le visuel téléchargé.',
    ASSISTANT_STEP_LINKEDIN_5: 'Vérifiez, puis publiez.',
    ASSISTANT_STEP_FACEBOOK_1: 'Facebook vient de s’ouvrir dans un nouvel onglet.',
    ASSISTANT_STEP_FACEBOOK_2: 'Cliquez dans la zone de publication.',
    ASSISTANT_STEP_FACEBOOK_3: 'Appuyez sur Ctrl + V pour coller le texte préparé par Emye.',
    ASSISTANT_STEP_FACEBOOK_4: "Vérifiez le texte et le lien de l'offre.",
    ASSISTANT_STEP_FACEBOOK_5: 'Cliquez sur Publier.',
    ASSISTANT_STEP_X_1: 'X vient de s’ouvrir dans un nouvel onglet.',
    ASSISTANT_STEP_X_2: 'Le texte et le lien sont déjà préremplis.',
    ASSISTANT_STEP_X_3: 'Vérifiez le contenu du post.',
    ASSISTANT_STEP_X_4: 'Ajustez le texte si nécessaire.',
    ASSISTANT_STEP_X_5: 'Cliquez sur Publier.',
    ASSISTANT_STEP_INDEED_1: 'Indeed vient de s’ouvrir dans un nouvel onglet.',
    ASSISTANT_STEP_INDEED_2: 'Ouvrez ou créez l’annonce concernée.',
    ASSISTANT_STEP_INDEED_3: 'Appuyez sur Ctrl + V pour coller le texte préparé par Emye.',
    ASSISTANT_STEP_INDEED_4: "Vérifiez les informations de l'offre.",
    ASSISTANT_STEP_INDEED_5: 'Publiez ou enregistrez l’annonce.',
    ASSISTANT_STEP_INSTAGRAM_1: 'Instagram vient de s’ouvrir.',
    ASSISTANT_STEP_INSTAGRAM_2: 'Créez une nouvelle publication.',
    ASSISTANT_STEP_INSTAGRAM_3: 'Ajoutez le visuel généré par Emye.',
    ASSISTANT_STEP_INSTAGRAM_4: 'Cliquez dans la zone de description.',
    ASSISTANT_STEP_INSTAGRAM_5: 'Appuyez sur Ctrl + V pour coller le texte.',
    ASSISTANT_STEP_INSTAGRAM_6: 'Vérifiez, puis publiez.',
    ASSISTANT_STEP_TIKTOK_1: 'TikTok vient de s’ouvrir.',
    ASSISTANT_STEP_TIKTOK_2: 'Créez une nouvelle publication.',
    ASSISTANT_STEP_TIKTOK_3: 'Ajoutez le visuel généré par Emye.',
    ASSISTANT_STEP_TIKTOK_4: 'Cliquez dans la zone de description.',
    ASSISTANT_STEP_TIKTOK_5: 'Appuyez sur Ctrl + V pour coller le texte.',
    ASSISTANT_STEP_TIKTOK_6: 'Vérifiez, puis publiez.',
    RECOPY_TEXT: 'Recopier le texte',
    REOPEN_NETWORK: 'Rouvrir {{network}}',
    OPEN_NETWORK: 'Ouvrir {{network}}',
    I_PUBLISHED: "J’ai publié",
    MARKED_PUBLISHED: 'Publication marquée comme terminée.',
    COPIED_CLIPBOARD: 'Texte et lien copiés. Collez-les dans la zone de publication.',
    LINK_COPIED_CLIPBOARD: 'Lien copié.',
    COPY_FAILED: 'Erreur lors de la copie. Veuillez réessayer.',
    POPUP_BLOCKED: "Le navigateur a bloqué l’ouverture du site. Autorisez les pop-ups, puis réessayez.",
    COPY_LINK: 'Copier le lien',
    CLOSE: 'Fermer',
    URL_PORTAL_MISSING: "Veuillez remplir l'URL portail.",
  },
}
